import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, ActionCreator } from '@ngrx/store';
import { catchError, of, OperatorFunction } from 'rxjs';

import { SerializedHttpErrorResponse } from '../interfaces';

type FailureActionType = ActionCreator<
    string,
    (props: { response: SerializedHttpErrorResponse }) => { response: SerializedHttpErrorResponse } & Action
>;

type FailureAction<T> = ({ response: SerializedHttpErrorResponse } & Action) | T;

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    /**
     * Serialize HttpErrorResponse
     */
    serializeResponse(response: HttpErrorResponse): SerializedHttpErrorResponse {
        const { headers, status, statusText, url, ok, type } = response;

        return {
            headers: this.serializeHeaders(headers),
            status,
            statusText,
            url,
            ok,
            type,
        } as SerializedHttpErrorResponse;
    }

    /**
     * Handles an HttpErrorResponse and returns the given action.
     */
    handleHttpErrorResponse<T>(
        action: FailureActionType,
        extraParametersForAction?: any,
    ): OperatorFunction<T, FailureAction<T>> {
        return (input$) =>
            input$.pipe(
                catchError((response: HttpErrorResponse) => {
                    const serializedResponse: SerializedHttpErrorResponse = this.serializeResponse(response);
                    const actionResponse = action({
                        response: serializedResponse,
                        ...extraParametersForAction,
                    });

                    console.warn({
                        action: actionResponse,
                        response,
                    });

                    return of(actionResponse);
                }),
            );
    }

    /**
     * Serializes HttpHeaders so it can be used in Action dispatches (due to strictActionSerializability)
     */
    private serializeHeaders(headers: HttpHeaders): {
        [key: string]: string | number;
    } {
        const keys = headers.keys();
        const responseHeader = {};

        keys.forEach((key) => {
            responseHeader[key] = headers.get(key);
        });

        return responseHeader;
    }
}
